import { Box, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

import React from "react";
import { StyledBookingFlowButton } from "../BookingScheduleContainer/BookingScheduleContainer.style";
import { WellnessSuccessAvatar } from "../../../components";
import { dateToString } from "../../../utils/unix-timestamp";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { PAGES_PATH } from "../../../navigation/params";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import useWellnessPurchaseData from "../../../hooks/redux-hooks/wellness-purchase-store/wellness-purchase-store";
import { getSpeciesName } from "../../../components/PageTitle/WellnessPlanTitle/WellnessPlanTitle";

const WellnessPlanSuccessContainer = () => {
  const { petList } = usePetStore();
  const [searchParams] = useSearchParams();
  const petId = searchParams.get("id");
  const navigate = useNavigate();
  const { wellnessPurchaseData } = useWellnessPurchaseData();


  const currentPet = petList?.filter((pet) => pet.id == petId);

  const handleNavgateCare = () =>{
    if (currentPet) {
      userActivityLogger(MIXPANEL_EVENTS.USER_CLICKS_EXPLORE_PLAN,
        { pet_id: petId,
          pet_name: currentPet[0].name,
          selected_plan: wellnessPurchaseData?.planType,
          species: getSpeciesName(currentPet[0]?.species),
        });
    }
    navigate(`${PAGES_PATH.PET_CARE}?id=${petId}&category=TotalCare_Plan`);
  };


  return (
    <>
      <Box className="bg-white flex flex-col justify-center items-center gap-5 w-full">
        <Box className="flex justify-between w-full relative -top-3 -right-2">
          <div></div>
        </Box>
        {currentPet && <WellnessSuccessAvatar image={currentPet[0]?.image} name={currentPet[0].name} />}
        <Typography
          textAlign={"center"}
          variant="h2"
          className="!font-semibold"
        >
          Woohoo! <span className="capitalize">{currentPet && currentPet[0].name}</span> is on the <br />
          {wellnessPurchaseData?.planName}
        </Typography>
        <Typography textAlign={"center"} className="bg-gray-2 shadow-sm p-1 flex justify-center tracking-wide md:px-16">
          We’ve sent you a confirmation email
        </Typography>
        <Typography textAlign={"center"} className="!w-full !mb-2" variant="body1">
          <span className="capitalize">{currentPet && currentPet[0].name}</span>’s{" "}
          plan starts {dateToString(new Date())}
        </Typography>
        <StyledBookingFlowButton
          fullWidth
          color="primary"
          size="small"
          className="!sticky !bottom-3"
          onClick={handleNavgateCare}
        >

            Explore Plan
        </StyledBookingFlowButton>
      </Box>
    </>
  );
};

export default WellnessPlanSuccessContainer;
